import { translate } from '@gig/magic-common';
import { ValidationDisplay, required } from '@gig/magic-form-builder';

function otp() {
    return {
        id: 'otp',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'otp',
        properties: {
            placeholder: translate('totp.corex.otp.placeholder'),
        },
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: required,
                message: translate('totp.corex.otp.required.error'),
            },
        ],
    };
}

export { otp };
